require.context("./assets/images", true, /\.(png|gif|jpe?g|svg)$/i);
